import CapexView from '../views/CapexView';
import CarbonView from '../views/CarbonView';
import EconomicsView from '../views/EconomicsView';
import FieldsView from '../views/FieldsView';
import InputsView from '../views/InputsView';
import LaborView from '../views/LaborView';
import OperationsView from '../views/OperationsView';
import RevenueView from '../views/RevenueView';
import YieldView from '../views/YieldView';
import MultiProjectDashboardView from '../views/MultiProjectDashboardView';

export const ECONOMICS_VIEWS = [
  {
    name: 'Summary',
    path: 'economics',
    element: <EconomicsView />,
    showSubsidySwitch: true,
  },
  {
    name: 'Yield',
    path: 'yield',
    element: <YieldView />,
  },
  {
    name: 'Revenue',
    path: 'revenue',
    element: <RevenueView />,
  },
  {
    name: 'Operations',
    path: 'operations',
    element: <OperationsView />,
    showSubsidySwitch: true,
  },
  {
    name: 'Labor',
    path: 'labor',
    element: <LaborView />,
  },
  {
    name: 'Inputs',
    path: 'inputs',
    element: <InputsView />,
  },
  {
    name: 'Capital',
    path: 'capex',
    element: <CapexView />,
    showSubsidySwitch: true,
  },
  {
    name: 'Carbon',
    path: 'carbon',
    element: <CarbonView />,
  },
];

export const ECON_SUBSIDY_VIEWS = ECONOMICS_VIEWS.filter(
  ({ showSubsidySwitch }) => showSubsidySwitch,
);

export const ECON_NON_SUBSIDY_VIEWS = ECONOMICS_VIEWS.filter(
  ({ showSubsidySwitch }) => !showSubsidySwitch,
);

export const FARM_DATA_VIEWS = [
  {
    name: 'Crops',
    path: '/crops',
  },
  {
    name: 'Materials & Fuel',
    path: '/inputs',
  },
  {
    name: 'Equipment & Infrastructure',
    path: '/capexes',
  },
  {
    name: 'Labor Rate',
    path: '/labor',
  },
  {
    name: 'Subsidy Settings',
    path: '/subsidies',
  },
];

export const READ_ONLY_DEVELOPER_TOOLS_VIEWS = [
  { name: 'Quote Summary', path: '/quote-summary' },
  {
    name: 'Operations Cost Basis',
    path: '/cost-basis/operations',
  },
  {
    name: 'Inputs Cost Basis',
    path: '/cost-basis/inputs',
  },
  {
    name: 'Capital Cost Basis',
    path: '/cost-basis/capex',
  },
];

export const DEVELOPER_TOOLS_VIEWS = [
  ...READ_ONLY_DEVELOPER_TOOLS_VIEWS,
  {
    name: 'Buffers',
    path: '/settings/buffers',
  },
  {
    name: 'Margins',
    path: '/settings/margins',
  },
];

export const FIELDS_VIEW = {
  name: 'Fields',
  path: 'fields',
  element: <FieldsView />,
};

export const MULTI_PROJECT_DASHBOARD_VIEW = {
  name: 'Multi Project Dashboard',
  path: 'dashboard',
  element: <MultiProjectDashboardView />,
};
